import "./App.css";

import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { HelmetProvider, Helmet } from "react-helmet-async";

import MainRoutes from "./js/Navigation/MainRoutes";

import Header from "./js/Components/Header";

function App() {
  // React.useEffect(() => {
  //   // Matomo initialization
  //   window._mtm = window._mtm || [];
  //   window._mtm.push({ "mtm.startTime": new Date().getTime(), event: "mtm.Start" });

  //   // Script insertion
  //   const scriptId = "matomo-script";
  //   if (!document.getElementById(scriptId)) {
  //     var d = document,
  //       g = d.createElement("script"),
  //       s = d.getElementsByTagName("script")[0];
  //     g.async = true;
  //     g.id = scriptId;
  //     g.src = "https://analytics.variass.nl/js/container_67i8aiaM.js";
  //     s.parentNode.insertBefore(g, s);
  //   }
  // }, []);

  return (
    <HelmetProvider>
      <Helmet>
        {/* Google Tag Manager */}
        <script>
          {`(function(w,d,s,l,i){w[l]=w[l]||[];
            w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js'});
            var f=d.getElementsByTagName(s)[0], 
              j=d.createElement(s),
              dl=l!='dataLayer'?'&l='+l:'';
            j.async=true;
            j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;
            f.parentNode.insertBefore(j,f); 
          })(window,document,'script','dataLayer','GTM-MPNR9XDP');
         `}
        </script>
        {/* End Google Tag Manager  */}
      </Helmet>

      {/* Google Tag Manager (noscript)  */}
      <noscript
        dangerouslySetInnerHTML={{
          __html: `<iframe src="https://www.googletagmanager.com/ns.html?id=GTM-MPNR9XDP" height="0" width="0" style="display:none;visibility:hidden"></iframe>`,
        }}
      ></noscript>
      {/* End Google Tag Manager (noscript)  */}
      <Router>
        <header>
          <Header />
        </header>
        <main>
          <MainRoutes />
        </main>
      </Router>
    </HelmetProvider>
  );
}

export default App;
